import { ListViewProvider, useListView } from '../core/ListViewProvider'
import { QueryRequestProvider, useQueryRequest } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { UsersListHeader } from '../components/header/UsersListHeader'
import { UsersTable } from '../table/UsersTable'
import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
import { KTCard, initialQueryState } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
// import { roleColumns } from './_columns'
// import { roleColumns } from './_columnsC'
import { roleColumns } from './_columnsOut'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getUserById } from '../core/_requests'
import { useAuth } from '../../../../auth'

const UsersList = () => {
  const { auth, isSupplyChainManager, currentUser } = useAuth()
  console.log("curr is", currentUser)
  const hideDropdown = auth?.data?.userType === 'SMART_CENTRE' || false
  const { data } = useQuery(
    `users?page=0&size=10&type=FRANCHISE`,
    () => getUserById('', 'users?page=0&size=10&type=FRANCHISE'),
    {
      enabled: hideDropdown,
      cacheTime: 0,
      onError: (err) => {
        console.warn(err)
      },
    }
  )



  const SearchIcon = () => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      style={{
        position: 'absolute',
        left: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#6B7280',
      }}
    >
      <circle cx='11' cy='11' r='8' />
      <line x1='21' y1='21' x2='16.65' y2='16.65' />
    </svg>
  )

  // const getInitialApi = () => {
  //   if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
  //     return 'collect/orders?page=0&size=10&wasteSource=C2B'
  //   }
  //   return 'collect/orders'
  // }


  const getInitialApi = () => {
    if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
      return 'collect/orders?wasteSource=C2B'  // Keep this as is
    }
    return 'collect/orders'
  }



  const [searchQuery, setSearchQuery] = useState('')
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.toLowerCase()
    setSearchQuery(query)

    // Get all table rows
    const tableRows = document.querySelectorAll('table tbody tr') as NodeListOf<HTMLTableRowElement>

    // Loop through each row
    tableRows.forEach((row: HTMLTableRowElement) => {
      const cells = row.querySelectorAll('td') as NodeListOf<HTMLTableCellElement>
      let found = false

      // Check each cell in the row
      cells.forEach((cell: HTMLTableCellElement) => {
        const text = cell.textContent?.toLowerCase() || ''
        if (text.includes(query)) {
          found = true
        }
      })

      // Show/hide row based on search match
      if (found) {
        row.style.display = ''
      } else {
        row.style.display = 'none'
      }
    })
  }


  const { updateState } = useQueryRequest()
  const [categoriesList, setCategoriesList] = useState([{ label: 'Select one', value: '' }])
  useEffect(() => {
    if (data && data.length) {
      let dropdownData: any = [{ label: 'Select one', value: '' }]
      data.map((eachData) => {
        return dropdownData.push({ label: eachData?.personalDetails?.name, value: eachData.id })
      })
      setCategoriesList(dropdownData)
      updateState({
        enabled: true,
        initialApi: `categories/${dropdownData[0]?.value}/items`,
        ...initialQueryState,
      })
    }
  }, [data])
  const searchElements = [
    {
      type: 'datePicker',
      name: 'start_date',
      label: 'Start date',
    },
    {
      type: 'datePicker',
      name: 'end_date',
      label: 'End date',
    },

    {
      ...(hideDropdown && {
        type: 'select',
        value: 'select',
        options: categoriesList,
        name: 'franchiseeid',
        label: 'Franchise',
      }),
    },
  ]
  const { itemIdForUpdate } = useListView()
  return (
    <KTCard>
      {/* <UsersListHeader
        showDownload
        showResetButton={true}
        initialApi='collect/orders'
        searchElements={searchElements}
        placeholder='Search Category'
      />
      <UsersTable
        initialApi='collect/orders'
        showPagination={true}
        columnProps={roleColumns(isSupplyChainManager)}
      /> */}
      {/* <UsersListHeader
        showDownload
        showResetButton={true}
        initialApi={getInitialApi()}  // Use the same function
        searchElements={searchElements}
        placeholder='Search Category'
      /> */}









      <div
        style={{
          position: 'relative',
          width: '300px',
          marginLeft: '30px',
          marginTop: '25px',
          // marginBottom: '-30px',
        }}
      >
        <SearchIcon />
        <input
          type='text'
          placeholder='Search record...'
          value={searchQuery}
          onChange={handleSearch}
          style={{
            width: '100%',
            height: '40px',
            padding: '8px 8px 8px 35px',
            fontSize: '14px',
            border: '1px solid #E5E7EB',
            borderRadius: '6px',
            outline: 'none',
            backgroundColor: 'white',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
          onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
        />
      </div>





      <UsersTable
        initialApi={getInitialApi()}  // Use the same function
        showPagination={true}
        columnProps={roleColumns(isSupplyChainManager)}
      />
      <UserEditModal
        // getByIdApi='collect/orders/'
        showViewPage={itemIdForUpdate?.showCertificate ? true : false}
        formName='IsccuViewImageForm'
      />
    </KTCard>
  )
}

// const CollectOrdersWrapper = () => (
//   <QueryRequestProvider initialValue={{ initialApi: 'collect/orders' }}>
//     <QueryResponseProvider>
//       <ListViewProvider>
//         <UsersList />
//       </ListViewProvider>
//     </QueryResponseProvider>
//   </QueryRequestProvider>
// )


const IsccOutput = () => {
  const { auth } = useAuth()

  const getInitialApi = () => {
    if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
      return 'productions?isBatchConsumed=false'
      // return 'productions?processType=DIVERSION'
    }
    return 'collect/orders'
  }

  return (
    <QueryRequestProvider initialValue={{ initialApi: getInitialApi(), size: 50 }}>
      <QueryResponseProvider>
        <ListViewProvider>
          <UsersList />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export { IsccOutput }
